<div class="wrapper cursor-pointer" id="notifications">
  <dx-button stylingMode="text"
             [icon]="'<svg>'+notifyIcon.body+'</svg>'"
             [elementAttr]="{class: 'notifications-menu-button'}"
             type="normal">
  </dx-button>
  <span *ngIf="total !=  '0'" class="button-badge">{{total}}</span>
</div>

<dx-popover
  class="notifications-popover"
  [width]="400"
  showEvent="dxclick"
  [showTitle]="true"
  target="#notifications"
  [elementAttr]="{class: 'notifications-popover'}"
  position="bottom"
  title="Notifications"
  [showCloseButton]="true"
  [closeOnOutsideClick]="true">
  <div *dxTemplate="let model of 'content'">
    <dx-scroll-view width="100%">
      <dx-list [dataSource]="ds"
               class="notifications-list"
               [noDataText]="'<div class=\'text-xs text-center p-4 w-full\'>Aucune notification</div>'"
               [focusStateEnabled]="false"
               (onItemClick)="itemClick($event)"
               itemTemplate="listItem">
        <div *dxTemplate="let data of 'listItem';">
          <div [ngClass]="{'unread': !data.read}" class="flex flex-row w-full">

            <div class="m-2">
              <span class="text-gray-700 text-sm block font-normal mb-1">{{data.message}}</span>
              <div class="flex items-center text-xs text-gray-500">
                <p>{{data.ago}}</p>
                <p class="px-1">•</p>
                <p>{{data.time | date:'yyyy-MM-dd HH:mm:ss'}}</p>
              </div>
            </div>

            <div #item class="text-center m-2 ml-auto self-center">
              <dx-button icon="more"></dx-button>
              <dx-context-menu
                [dataSource]="[{id: data.id, text: 'Marquer comme lu', action: 'read', icon:'read'}]"
                [width]="100"
                showEvent="click"
                (onItemClick)="contextMenuClick($event)"
                [target]="item">
                <div class="text-gray-700 text-sm" *dxTemplate="let m of 'item'; let i = index">
                  <span class="ml-2">{{m.text}}</span>
                </div>
              </dx-context-menu>
            </div>

          </div>
        </div>
      </dx-list>
    </dx-scroll-view>
  </div>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="top"
    location="after"
    [options]="{ icon: 'refresh',
    hint: 'Rafraîchir',
    onClick: reload,
     stylingMode: 'text'}">
  </dxi-toolbar-item>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{ text: 'Lire tout',
    hint: 'Marquer tout comme lu',
    onClick: readAll,
     stylingMode: 'text',
  type: 'default' }">
  </dxi-toolbar-item>
</dx-popover>
